import React from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from '../../../../../components/Common/modal/Modal';

interface ModalsProps {
  showPlanModal: boolean;
  showRelaxModeModal: boolean;
  setShowRelaxModeModal: (value: boolean) => void;
  startStepFour: () => void;
}

const Modals: React.FC<ModalsProps> = ({ showPlanModal, showRelaxModeModal, setShowRelaxModeModal, startStepFour }) => {
  const navigate = useNavigate();

  return (
    <>
      {showPlanModal && (
        <Modal
          title="Plan Purchase"
          description="You can regenerate when using a purchased plan, why not first see your character brought to life in a story?"
          doProcess={() => navigate('/myPlans')}
          showCloseButton={false}
          showPromoFreeBook={true}
          characterRegenerate={true}
          continueBook={startStepFour}
          submitButtonTitle="Purchase Plan"
        />
      )}
      {showRelaxModeModal && (
        <Modal
          description="Sorry, you have run out of image credits. You can still access all images you’ve created so far by clicking on ‘Image Library’."
          doProcess={() => setShowRelaxModeModal(false)}
          showCloseButton={false}
          showSubmitButton={true}
          submitButtonTitle={'Continue'}
        />
      )}
    </>
  );
};

export default Modals;
